var mrsDevConfig = {
  production: false,
  appName: 'mrs',
  baseURL: 'http://localhost:8081/',
  media: "https://media.mirasee/",
  api: "https://api.mirasee/v2/",
  apiv3: "http://localhost:8080/api/v3/",
  cartUrl: "https://api.ultracart.com/",
};

var mrsProdConfig = {
  production: true,
  appName: 'mrs',
  baseURL: 'https://mirasee.com/2025/',
  media: "https://media.mirasee.com/",
  api: "https://api.mirasee.com/v2/",
  apiv3: "https://api.mirasee.com/v3/",
  cartUrl: "https://api.ultracart.com/",
};

if (process.env.NODE_ENV == 'development')
  var mrsConfig = mrsDevConfig;
else
  mrsConfig = mrsProdConfig;

export default mrsConfig;
